<template>
  <div>
    <v-data-table
      show-expand
      :headers="headers"
      :items="produtos.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="produtos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum produto encontrado"
      loading-text="Carregando produtos..."
      :options="optionsList"
    >
      <template v-slot:item.codigo="{ item }">
        {{ item.codigo | naoInformado }}
      </template>
      <template v-slot:item.ncm="{ item }">
        {{ item.ncm | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon
               @click="goToEditProduto(item, false)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   @click="onClickCopy(item)" v-on="on">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copiar produto</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length" class="grey lighten-4 expanded-item">
          <v-row class="mt-2">
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Especificação</span>
              <div>
                <px-show-large-text :large-text="item.especificacao"/>
              </div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
export default {
  props: {
    produtos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código interno',
          value: 'codigo',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Unidade de medida',
          value: 'unidadeMedida.descricao',
        },
        {
          text: 'Categoria',
          value: 'origem.descricao',
        },
        {
          text: 'NCM',
          value: 'ncm',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {},
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditProduto(item, isCopy) {
      this.$router.push({
        name: 'main.produto.edicao',
        params: {
          id: item.id,
          isCopy,
        },
      });
    },
    onClickCopy(item) {
      this.goToEditProduto(item, true);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este produto?',
        'O produto será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
